/* document.addEventListener("click", function(e){

    const trigger = e.target.closest(".size-chart-trigger");
    const close = e.target.closest(".size-chart-close");
    const overlay = e.target.closest(".size-chart-overlay");

    if(trigger){

        document
            .querySelector("#SizeChartDrawer")
            .classList.add("active");

        document.body.style.overflow = "hidden";
    }

    if(close || overlay){

        document
            .querySelector("#SizeChartDrawer")
            .classList.remove("active");

        document.body.style.overflow = "";
    }

}); */
document.addEventListener("click", function (e) {
  const drawer = document.querySelector("#SizeChartDrawer");
  const header = document.querySelector(
    '.header-section:has(> #header-component[sticky="always"])'
  );

  if (e.target.closest(".size-chart-trigger")) {
    drawer.classList.add("active");

    if (header) {
      header.style.zIndex = "1";
    }

    document.body.style.overflow = "hidden";
  }

  if (
    e.target.closest(".size-chart-close") ||
    e.target.closest(".size-chart-overlay")
  ) {
    drawer.classList.remove("active");

    if (header) {
      header.style.removeProperty("z-index");
      // or: header.style.zIndex = "";
    }

    document.body.style.overflow = "";
  }
});